import { Select, styled } from "@mui/material";

const MuiSelect = styled(Select)(({ theme }) => ({
  paddingTop: 0,
  "&.MuiInput-root": {
    marginTop: 0,
  },
  "& .MuiSelect-select": {
    paddingTop: "10px",
    "&.MuiSelect-outlined": {
      minHeight: "1.26em",
      textAlign: "left",
      borderWidth: "4px",
    },
    "&.MuiSelect-standard": {
      minWidth: "40px",
      paddingTop: 0,
      // textAlign: "left",
    },
  },
  "& .MuiInputBase-input ": {
    ...theme.typography.h6,
    padding: "8.1px 14px 8.1px 12px",
  },
  "& .MuiSvgIcon-root ": {
    height: '1rem',
    width: '1rem',
    top: 'calc(50% - 0.5rem)'
  },
}));

export default MuiSelect;
